import { render, staticRenderFns, recyclableRender, components } from "./packaging-worker.vue?vue&type=template&id=24d2eaf4&scoped=true&"
var renderjs
import script from "./packaging-worker.vue?vue&type=script&lang=js&"
export * from "./packaging-worker.vue?vue&type=script&lang=js&"
import style0 from "./packaging-worker.vue?vue&type=style&index=0&lang=css&"
import style1 from "./packaging-worker.vue?vue&type=style&index=1&id=24d2eaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2eaf4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/packaging-worker/packaging-worker.vue"
export default component.exports